/*
 * 计划与报告模块接口
 */

import { post, get, put, del } from 'api/http'

export default {
    // 获取计划的合同信息
    getContractList(data) {
        // return get('/app/maintenance_plan/contract', data)
        return get('/wx/plan/findPlan', data, 'javaHost')
    },
    // 获取计划的列表信息
    getPlanList(data) {
        // return get('/app/maintenance_plan', data)
        return get('/wx/plan/getPlan', data, 'javaHost')
    },
    // 获取计划的 详情信息
    getPlanDetail(data) {
        // return get('/app/maintenance_plan', data)
        return get('/plan/detail', data, 'javaHost')
    },

    // 新增计划
    addPlan(data) {
        // return post('/app/maintenance_plan', data)
        return post('/plan/save', data, 'javaHost')
    },

    // 编辑计划
    updatePlan(data) {
        // return put('/app/maintenance_plan', data)
        return post('/plan/edit', data, 'javaHost')
    },

    // 删除计划
    deletePlan(data) {
        // return del('/app/maintenance_plan', data)
        return get('/plan/delete', data, 'javaHost')
    },

    // 指定人员
    getPlanPeople(data) {
        // return get('/app/maintenance_plan/people', data)
        return get('/plan/employee/list', data, 'javaHost')
    },

    // 设备系统，维保内容
    getDeviceSys(data) {
        // return get('/pc/maintenance_plan/sys', data)
        return get('/firefighting/getPlanSysInfo', data, 'javaHost')
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/ems/plan.js